'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import Navbar from './Navbar';

/**
 * ConditionalNavbar - Wraps the Navbar component and conditionally renders it
 * based on the current route. This allows certain pages (like /stream and the
 * /labs/workspace sandbox) to have a full-screen experience without the navbar.
 * ?embed=1 renders ANY page chrome-free (workspace chart embeds, shareable charts).
 */
export default function ConditionalNavbar() {
  const pathname = usePathname();
  const [embed, setEmbed] = useState(false);

  useEffect(() => {
    try { setEmbed(new URLSearchParams(window.location.search).get('embed') === '1'); } catch { /* ssr */ }
  }, [pathname]);

  // Routes that should NOT show the navbar (full-screen experience)
  const noNavbarRoutes = ['/stream', '/labs/workspace'];
  const shouldHideNavbar = noNavbarRoutes.includes(pathname) || embed;

  if (shouldHideNavbar) {
    return null;
  }

  return <Navbar />;
}
